import { Box } from '@mui/material';
// import { ConnectAccountOnboarding, ConnectComponentsProvider } from '@stripe/react-stripe-js';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { ConnectAccountOnboarding, ConnectComponentsProvider } from '@stripe/react-connect-js';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CONNECTED_ACCOUNT_LOAD_FINISHED } from '../../constants/actionTypes';
import fetch from '../../fetch';
import NavMobile from '../Nav/NavMobile';
import NavDesktop from '../Nav/NavDesktop';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser,
        company: state.common.company,
        connected_account: state.common.connected_account,
        connected_products: state.common.connected_products,
        connected_prices: state.prices.connected_prices
    };
};

const mapDispatchToProps = (dispatch) => ({
    setConnectedAccount: (payload) => dispatch({ type: CONNECTED_ACCOUNT_LOAD_FINISHED, payload })
});

const baseDomain = process.env.REACT_APP_API_URL?.split('api')[1];

const Onboard = (props) => {
    const [stripeErrorMessage, setStripeErrorMessage] = useState('');
    const [stripeConnectInstance, setStripeConnectInstance] = useState();
    const history = useHistory();

    const metadata = props.connected_account?.metadata
        ? JSON.parse(props.connected_account?.metadata)
        : {};

    const fetchClientSecret = async () => {
        try {
            let localDomain = undefined;
            const hostname = window.location.hostname;
            if (hostname === 'localhost' || hostname === '127.0.0.1') {
                localDomain = 'http://localhost:3000';
            }
            const domain = !props.company.domain
                ? `${props.company?.name}${baseDomain}`
                : props.company.domain;
            const companyDomain = localDomain || `https://${domain}`;
            const stripeAccountOnboardingInput = {
                companyId: props.company._id,
                companyDomain,
                country: metadata.country,
                email: metadata.email,
                business_type: props.company.business_type,
                firstName: metadata.firstName,
                lastName: metadata.lastName,
                callback_path: '/home'
            };
            let stripeLink = await fetch.StripeAccount.createAccountStripe({
                method: 'POST',
                body: JSON.stringify(stripeAccountOnboardingInput)
            });

            if (stripeLink) {
                return stripeLink.session;
            }
        } catch (e) {
            console.log('ERROR: ', e);
            setStripeErrorMessage(e.message);
            return;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setStripeConnectInstance(
                loadConnectAndInitialize({
                    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
                    fetchClientSecret: fetchClientSecret,
                    appearance: {
                        variables: {
                            colorPrimary: '#000000',
                            buttonPrimaryColorBackground: '#04C900',
                            buttonSecondaryColorBackground: '#04C900',
                            fontFamily: '"InstrumentSans", sans-serif',
                            labelMdFontWeight: '200 !important'
                        }
                    }
                })
            );
        };
        if (props.company) {
            fetchData();
        }
    }, [props.company]);

    const redirectToHome = async () => {
        const account = await fetch.StripeAccount.getAccountByCompany(
            process.env.REACT_APP_COMPANY_ID
        );
        if (account) {
            props.setConnectedAccount(account);
        }
        setTimeout(() => {
            history.goBack();
        }, 2000);
    };

    return (
        <Box>
            {isMobile ? <NavMobile /> : <NavDesktop />}

            <Box sx={{ padding: isMobile ? '1rem 1rem 0 1rem' : '1rem 3rem 0rem' }}>
                {stripeConnectInstance && (
                    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                        <ConnectAccountOnboarding
                            onExit={() => {
                                redirectToHome();
                            }}
                            // Optional: make sure to follow our policy instructions above
                            // fullTermsOfServiceUrl="{{URL}}"
                            // recipientTermsOfServiceUrl="{{URL}}"
                            // privacyPolicyUrl="{{URL}}"
                            // skipTermsOfServiceCollection={false}
                            // collectionOptions={{
                            //   fields: 'eventually_due',
                            //   futureRequirements: 'include',
                            // }}
                            // onStepChange={(stepChange) => {
                            //   console.log(`User entered: ${stepChange.step}`);
                            // }}
                        />
                    </ConnectComponentsProvider>
                )}
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Onboard);
